import React from 'react'

import { isEmpty } from 'ramda'

import { Div } from '@driftt/tide-core'

import ChartLoader from '../ChartLoader'
import { ChartErrorState, ChartNoDataState } from '../ChartStates'

import './style.css'

export interface IChartBodyProps<T> {
  loading?: boolean
  error?: boolean
  data?: T
  noDataDescription?: React.ReactNode
  onErrorRetryClick?: () => void
  renderData?: (data: T) => React.ReactNode
  noDataTitle?: string
  noDataSubtitle?: string
  noDataIcon?: any
}

const ChartBody = <T extends object>({
  loading,
  noDataDescription,
  error,
  onErrorRetryClick,
  data,
  renderData,
  noDataTitle,
  noDataSubtitle,
  noDataIcon,
}: IChartBodyProps<T>) => {
  if (error) {
    return <ChartErrorState onRetryClick={onErrorRetryClick} />
  }

  if (loading) {
    return <ChartLoader />
  }

  if (data && !isEmpty(data) && renderData) {
    return <Div className="chart-body-data">{renderData(data)}</Div>
  }
  return (
    <ChartNoDataState
      title={noDataTitle}
      subtitle={noDataSubtitle}
      description={noDataDescription}
      icon={noDataIcon}
    />
  )
}

export default ChartBody
